import React, { useContext, useEffect, useState, useCallback } from "react";
import DrHistorySummaryDR from "../../DailyReviewSummaries/HistorySummaryDR/DrHistorySummaryDR";
import DrGeneralExaminationSummaryDR from "../../DailyReviewSummaries/GeneralExaminationSummaryDR/DrGeneralExaminationSummaryDR";
import DrSystemicExaminationSummaryDR from "../../DailyReviewSummaries/SystemicExaminationSummaryDR/DrSystemicExaminationSummaryDR";
import { getDoctorDailyReviewAPI } from "../../../../services/doctor.services";
import { DailyReviewContext } from "./DailyReviewFormProvider";
import { Button, Col, Row, Tag, message } from "antd";
import "../../summary.css";
import "./DailyReview.css";
import NoDataPage from "../../../NoDataPages/NoDataPage";
import noReview from "../../../../assets/doctorIcons/noReview.svg";
import LoadingIndicator from "../../../Loaders/LoadingIndicator";
import dayjs from "dayjs";
import DrClinicalImpressionSummary from "../../InspectionSummaries/ClinicalImpressionSummary/DrClinicalImpressionSummary";
import { checkEmpty } from "../../../../helpers/utility";
import EditIcon from "../../../ui/EditIcon";
import btnStyles from "../../../../styles/Custom/Button.module.css";

const checkEmptyData = (data) => {
  return (
    Object.keys(data?.clinical_diagnosis || {}).length === 0 &&
    !data?.functional_diagnosis &&
    Object.keys(data?.general_examination?.gcs || {}).length === 0 &&
    Object.keys(data?.history || {}).length === 0
  );
};

const DailyReviewSummary = ({
  editId,
  dailyRefresh,
  isActive = false,
  onEdit,
  canEdit = false,
}) => {
  const [loading, setLoading] = useState(true);
  const { formData, setFormData } = useContext(DailyReviewContext);
  const [noData, setNoData] = useState(true);

  const openEdit = useCallback(async () => {
    if (editId) {
      try {
        const response = await getDoctorDailyReviewAPI(editId);
        const data = response.data.data;

        setFormData(data);
        setNoData(!checkEmpty(data));
      } catch (error) {
        console.log(`Error: ${error}`);
        message.error("Unable to Fetch Data");
      } finally {
        setLoading(false);
      }
    }
  }, [editId, setFormData]);

  useEffect(() => {
    openEdit();
  }, [openEdit, dailyRefresh]);

  return (
    <>
      {loading ? (
        <LoadingIndicator message={"Loading..."} />
      ) : (
        <Row
          className="summaries daily-review-summaries"
          gutter={[16, 16]}
        >
          {noData ? (
            <Col span={24}>
              <NoDataPage
                title={"No Review Data Available on This Date"}
                image={noReview}
              />
            </Col>
          ) : (
            <>
              <Col span={24}>
                <div className="daily-review-meta-bar">
                  {(formData?.submitted_by_first_name ||
                    formData?.submitted_by_last_name) && (
                    <Tag className="daily-review-meta-tag--submitted">
                      Submitted by: {formData?.submitted_by_first_name || ""}{" "}
                      {formData?.submitted_by_last_name || ""}
                    </Tag>
                  )}
                  <div className="daily-review-meta-bottom">
                    {formData?.updated_at && (
                      <Tag className="daily-review-meta-tag--updated">
                        Updated at:{" "}
                        {dayjs(formData?.updated_at).format(
                          "DD/MM/YYYY hh:mm A"
                        )}
                      </Tag>
                    )}
                    {isActive && (
                      <div className="daily-review-meta-actions--mobile">
                        <Button
                          type="primary"
                          onClick={onEdit}
                          className={`${btnStyles.lgBtn} inv-btn`}
                          disabled={!canEdit}
                          style={{ fontWeight: 500 }}
                        >
                          <EditIcon />
                          Edit
                        </Button>
                      </div>
                    )}
                  </div>
                </div>
              </Col>
              {/* xs=24 stacks on mobile; md+ keeps two-column web layout */}
              <Col xs={24} md={12}>
                {formData?.clinical_diagnosis && (
                  <DrClinicalImpressionSummary context={DailyReviewContext} />
                )}
                {formData?.history && <DrHistorySummaryDR />}
              </Col>
              <Col xs={24} md={12}>
                {formData?.general_examination && (
                  <DrGeneralExaminationSummaryDR />
                )}
                {checkEmpty(formData?.systemic_examination) && (
                  <DrSystemicExaminationSummaryDR />
                )}
              </Col>
            </>
          )}
        </Row>
      )}
    </>
  );
};

export default DailyReviewSummary;
